import { render, staticRenderFns } from "./issueCard.vue?vue&type=template&id=401097fc&scoped=true&"
import script from "./issueCard.vue?vue&type=script&lang=js&"
export * from "./issueCard.vue?vue&type=script&lang=js&"
import style0 from "./issueCard.vue?vue&type=style&index=0&id=401097fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401097fc",
  null
  
)

export default component.exports